import { render, staticRenderFns } from "./SFTPIntegration.vue?vue&type=template&id=8e08af44&scoped=true&"
import script from "./SFTPIntegration.vue?vue&type=script&lang=ts&"
export * from "./SFTPIntegration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e08af44",
  null
  
)

export default component.exports